import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@styles/color.styles";

export const control: CSSProperties = {
  padding: 13,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: greys.borderGrey,
  borderRadius: 10,
  marginBottom: 14,
  cursor: "pointer",
  userSelect: "none",

  "&:hover": {
    backgroundColor: greys.palePaleGrey,
  },

  "& svg": {
    color: greys.blueGrey,
    marginRight: 13,
  },

  "&.on": {
    borderColor: colors.green.darker,

    "& svg": {
      color: colors.green.darker,
    },
  },

  "&:last-child": {
    marginBottom: 0,
  },
};

const controlContent: CSSProperties = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

const disabled: CSSProperties = {
  cursor: "not-allowed",
  opacity: 0.75,
  WebkitFilter: "grayscale(45%)",
  filter: "grayscale(45%)",
  "&:hover": {
    backgroundColor: "inherit",
  },
};

const pointerEventsNone: CSSProperties = {
  pointerEvents: "none",
};

const horizontal: CSSProperties = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
};

export const styles = {
  control,
  controlContent,
  disabled,
  pointerEventsNone,
  horizontal,
};
